import { Popover, Skeleton } from "antd";
import styles from "./index.module.scss";
import whiteWarn from "@/assets/images/whiteWarn.svg";
import { formatUnits } from "ethers";
import { getAprs } from "../../store/grpc_client";

import { useEffect, useState } from "react";
import { contract_address, getChainInfoById } from "@/constants/const";
import { Contract, JsonRpcProvider } from "ethers";
import {
  MarketViewer_Contract_ABI,
  StakingViewer_Contract_ABI,
} from "@/constants/abi";
import { getLastTimeString, ProverData } from "../AppList";
import StakeCard from "./StakeCard";
import {
  formatBalance,
  formatDecimalWithSeparation,
} from "celer-web-utils/lib/format";
import { formatTokenToUSD, formatTokenAmount } from "@/util";
import { useDataStore } from "@/store/dataStore";
import { useAccount } from "wagmi";
import StakeModal, { tokenDecimals, tokenSymbol } from "../modals/StakeModal";
import UnStakeModal from "../modals/UnStakeModal";
import { useModalStore } from "@/store/modle";

export const MoreDetailsContent = ({
  styleName,
  data,
  tokenPrice,
}: {
  styleName?: string;
  data?: ProverData;
  tokenPrice: number;
}) => {
  return (
    <div className={`${styles.moreDetailsContent} ${styles[styleName || ""]}`}>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>Total staked</div>
        <div className={styles.moreDetailsContentRight}>
          {data?.stakedFormatted} {tokenSymbol}
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>APR</div>
        <div className={styles.moreDetailsContentRight}>
          {data?.apr ? (
            `${data?.aprFormatted}%`
          ) : (
            <>
              <span
                style={{
                  color: "rgba(43, 48, 59, 0.6)",
                  cursor: "auto",
                }}
              >
                N/A
              </span>
              {/* <Popover
                placement="top"
                content={`APR is currently unavailable, as no ${localStorage.getItem(
                  "symbol"
                )} is staked yet.`}
                rootClassName={styles.stakingPopover}
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover> */}
            </>
          )}
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>
          Number of proofs submitted
        </div>
        <div
          className={styles.moreDetailsContentRight}
          style={{
            color: data?.proofsWon === 0 ? "rgba(43, 48, 59, 0.6)" : "#2b303b",
          }}
        >
          {data?.proofsWon}
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>Fee received</div>
        <div
          className={styles.moreDetailsContentRight}
          style={{
            color: data?.proofsWon === 0 ? "rgba(43, 48, 59, 0.6)" : "#2b303b",
          }}
        >
          <div>
            {data?.feeReceived === 0 ? (
              `0 ${tokenSymbol}`
            ) : (
              <Popover
                placement="top"
                content={`${data?.feeReceived} ${tokenSymbol}`}
                rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
              >
                {Number(data?.feeReceived) < 0.01
                  ? `< 0.01 ${tokenSymbol}`
                  : data?.feeReceivedFormatted}
              </Popover>
            )}{" "}
            <span
              style={{
                color: "rgba(43, 48, 59, 0.3)",
                fontSize: "12px",
                lineHeight: "16px",
                marginLeft: "4px",
                cursor: "auto",
              }}
            >
              (
              {formatTokenToUSD(
                data?.fee?.toString(),
                tokenDecimals,
                tokenPrice
              ) === 0 ? (
                "$0"
              ) : (
                <Popover
                  placement="top"
                  content={`$${formatBalance(
                    formatTokenToUSD(
                      data?.fee?.toString(),
                      tokenDecimals,
                      tokenPrice
                    ),
                    8,
                    "floor",
                    ",",
                    true
                  )}`}
                  rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
                >
                  {formatTokenToUSD(
                    data?.fee?.toString(),
                    tokenDecimals,
                    tokenPrice
                  ) < 0.01
                    ? "$<0.01"
                    : `$${formatBalance(
                        formatTokenToUSD(
                          data?.fee?.toString(),
                          tokenDecimals,
                          tokenPrice
                        ),
                        4,
                        "floor",
                        ",",
                        true
                      )}`}
                </Popover>
              )}
              ){/* </Popover> */}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>Success rate</div>
        <div
          className={`${styles.moreDetailsContentRight} ${
            styles[`${styleName}_moreDetailsSuccessRate`]
          }`}
          style={{ color: "#1C9444" }}
        >
          {data?.successRateFormatted === "0.00" ? (
            <>
              <div style={{ color: "rgba(43, 48, 59, 0.6)" }}>N/A</div>
              <Popover
                placement="top"
                content={
                  "Success rate is currently unavailable, as no proof requests have been fulfilled yet."
                }
                rootClassName={styles.stakingPopover}
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
            </>
          ) : (
            `${data?.successRateFormatted}%`
          )}
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>Joined since</div>
        <div className={styles.moreDetailsContentRight}>
          {data?.joinedSinceFormatted}
        </div>
      </div>
      <div className={styles.moreDetailsContentItem}>
        <div className={styles.moreDetailsContentLeft}>Last active</div>
        <div
          className={styles.moreDetailsContentRight}
          style={{
            color:
              data?.lastActiveFormatted === "--" ? "rgba(43, 48, 59, 0.6)" : "",
          }}
        >
          {data?.lastActiveFormatted}
        </div>
      </div>
    </div>
  );
};

export default function Dashboard() {
  const isMobile = useDataStore((state) => state.isMobile);

  // const [active, setActive] = useState(false);
  const { refreshData, tokenPrice } = useDataStore((state) => state);
  const { showUnStakeModal, showStakeModal } = useModalStore((state) => state);

  const [stakeList, setStakeList] = useState<ProverData[]>([]);

  const [totalStake, setTotalStake] = useState<string>("");
  const [totalStakeDecimal, setTotalStakeDecimal] = useState<string>("");

  const [totalPending, setTotalPending] = useState<string>("");
  const [totalPendingDecimal, setTotalPendingDecimal] = useState<string>("");

  const [totalWithdrawable, setTotalWithdrawable] = useState<string>("");
  const [totalWithdrawableDecimal, setTotalWithdrawableDecimal] =
    useState<string>("");

  const [loading, setLoading] = useState<boolean>(true);

  const { address } = useAccount();

  const threshold = 10n ** (BigInt(tokenDecimals) - 2n);

  useEffect(() => {
    if (!address) return;
    const provider = new JsonRpcProvider(
      getChainInfoById(
        Number(process.env.REACT_APP_PUBLIC_CLAIM_CHAIN || 59144)
      ).rpcUrl
    );

    const market_viewer_contract = new Contract(
      contract_address.market_viewer || "",
      MarketViewer_Contract_ABI,
      provider
    );

    const staking_viewer_contract = new Contract(
      contract_address.staking_viewer || "",
      StakingViewer_Contract_ABI,
      provider
    );

    Promise.all([staking_viewer_contract.getUserPortfolio(address)]).then(
      (res) => {
        const totalValueDecimal = formatUnits(
          res[0].totalValue || 0,
          Number(tokenDecimals)
        );
        setTotalStakeDecimal(totalValueDecimal);

        if (res[0].totalValue > 0n && res[0].totalValue < threshold) {
          const totalValue = "<0.01";
          setTotalStake(totalValue);
        } else {
          const totalValue = formatDecimalWithSeparation(
            res[0].totalValue?.toString(),
            2,
            tokenDecimals,
            "floor",
            ",",
            true
          );
          setTotalStake(totalValue);
        }

        const totalWithdrawableDecimal = formatUnits(
          res[0].totalReadyToWithdraw || 0,
          Number(tokenDecimals)
        );
        setTotalWithdrawableDecimal(totalWithdrawableDecimal);
        if (
          res[0].totalReadyToWithdraw > 0n &&
          res[0].totalReadyToWithdraw < threshold
        ) {
          const totalWithdrawable = "<0.01";
          setTotalWithdrawable(totalWithdrawable);
        } else {
          const totalWithdrawable = formatDecimalWithSeparation(
            res[0].totalReadyToWithdraw?.toString(),
            2,
            tokenDecimals,
            "floor",
            ",",
            true
          );
          setTotalWithdrawable(totalWithdrawable);
        }

        const totalTotalPendingDecimal = formatUnits(
          res[0].totalUnstaking - res[0].totalReadyToWithdraw,
          Number(tokenDecimals)
        );
        setTotalPendingDecimal(totalTotalPendingDecimal);
        if (
          res[0].totalUnstaking - res[0].totalReadyToWithdraw > 0n &&
          res[0].totalUnstaking - res[0].totalReadyToWithdraw < threshold
        ) {
          const totalPending = "<0.01";
          setTotalPending(totalPending);
        } else {
          const totalPending = formatDecimalWithSeparation(
            res[0].totalUnstaking - res[0].totalReadyToWithdraw,
            2,
            tokenDecimals,
            "floor",
            ",",
            true
          );
          setTotalPending(totalPending);
        }

        let stakeData: ProverData[] = [];

        let proversAddr: string[] = res[0].stakes
          .filter((stake: any) => stake.prover)
          .map(async (stake: any, idx: number) => {
            stakeData[idx] = stakeData[idx] || {};

            const proverStakedDecimal = formatUnits(
              stake.currentValue || 0,
              Number(tokenDecimals)
            );
            stakeData[idx].proverStakedDecimal = proverStakedDecimal;
            if (stake.currentValue > 0n && stake.currentValue < threshold) {
              stakeData[idx].proverStakedFormatted = "<0.01";
            } else {
              stakeData[idx].proverStakedFormatted =
                formatDecimalWithSeparation(
                  stake.currentValue?.toString(),
                  2,
                  tokenDecimals,
                  "floor",
                  ",",
                  true
                );
            }
            stakeData[idx].proverStaked = stake.currentValue;
            stakeData[idx].totalShares = stake.shares;

            stakeData[idx].pendingUnstake = BigInt(
              stake.totalUnstaking - stake.readyToWithdraw
            );
            const pendingUnstakeDecimal = formatUnits(
              stake.totalUnstaking - stake.readyToWithdraw,
              Number(tokenDecimals)
            );

            stakeData[idx].pendingUnstakeDecimal = pendingUnstakeDecimal;

            if (
              stake.totalUnstaking - stake.readyToWithdraw > 0n &&
              stake.totalUnstaking - stake.readyToWithdraw < threshold
            ) {
              stakeData[idx].pendingUnstakeFormatted = "<0.01";
            } else {
              stakeData[idx].pendingUnstakeFormatted =
                formatDecimalWithSeparation(
                  stake.totalUnstaking - stake.readyToWithdraw,
                  2,
                  tokenDecimals,
                  "floor",
                  ",",
                  true
                );
            }

            stakeData[idx].withdrawable = stake.readyToWithdraw;
            const withdrawableDecimal = formatUnits(
              stake.readyToWithdraw,
              Number(tokenDecimals)
            );
            stakeData[idx].withdrawableDecimal = withdrawableDecimal;

            if (
              stake.readyToWithdraw > 0n &&
              stake.readyToWithdraw < threshold
            ) {
              stakeData[idx].withdrawableFormatted = "<0.01";
            } else {
              stakeData[idx].withdrawableFormatted =
                formatDecimalWithSeparation(
                  stake.readyToWithdraw,
                  2,
                  tokenDecimals,
                  "floor",
                  ",",
                  true
                );
            }
            return stake.prover;
          });

        Promise.allSettled([
          market_viewer_contract.batchGetProverStatsComposite(proversAddr),
          staking_viewer_contract.getProversInfo(proversAddr),
          getAprs(),
        ]).then((ress) => {
          if (
            ress[0].status === "fulfilled" &&
            ress[1].status === "fulfilled"
          ) {
            ress[0].value.forEach((el: any, idx: number) => {
              stakeData[idx] = stakeData[idx] || {};

              stakeData[idx].proofsWon = Number(el.fulfilled);
              stakeData[idx].successRate = Number(el.successRateBps);
              stakeData[idx].successRateFormatted = (
                Number(el.successRateBps) / 100
              ).toFixed(2);

              const fee = (el.recent.feeReceived * 100n) / 90n;
              const feeNumber = Number(formatUnits(fee, Number(tokenDecimals)));

              let feeReceivedFormatted = "";
              if (feeNumber > 0 && feeNumber < 0.01) {
                feeReceivedFormatted = `<0.01 ${tokenSymbol}`;
              } else if (feeNumber === 0) {
                feeReceivedFormatted = `0 ${tokenSymbol}`;
              } else {
                feeReceivedFormatted = formatTokenAmount(
                  fee,
                  tokenDecimals,
                  tokenSymbol
                );
              }

              stakeData[idx].feeReceived = feeNumber;
              stakeData[idx].feeReceivedFormatted = feeReceivedFormatted;
              stakeData[idx].fee = fee;
              // stakeData[idx].feeReceived = Number(el.recent.feeReceived);
              // stakeData[idx].feeReceivedFormatted = formatDecimalWithSeparation(
              //   el.recent.feeReceived?.toString(),
              //   2,
              //   tokenDecimals,
              //   "floor",
              //   ",",
              //   true
              // );
              stakeData[idx].lastActive =
                Number(el.recent.lastActiveAt) || Number(el.total.lastActiveAt);
              stakeData[idx].lastActiveFormatted = getLastTimeString(
                el.recent.lastActiveAt || el.total.lastActiveAt
              );
            });
            ress[1].value.forEach((el: any, idx: number) => {
              stakeData[idx] = stakeData[idx] || {};

              stakeData[idx].stakedFormatted = formatDecimalWithSeparation(
                el.vaultAssets?.toString(),
                0,
                tokenDecimals,
                "floor",
                ",",
                true
              );
              stakeData[idx].staked = el.vaultAssets;

              const date = new Date(Number(el.joinedAt) * 1000);
              const formattedDate = date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
              stakeData[idx].proverName = el.name;
              stakeData[idx].proverAddress = el.prover;
              stakeData[idx].proverIcon = el.iconUrl;
              stakeData[idx].joinedSince = Number(el.joinedAt);
              stakeData[idx].joinedSinceFormatted = formattedDate;
              stakeData[idx].isActive = Number(el.state) === 1 ? true : false; //1 ProverState.Active
              if (ress[2].status === "fulfilled") {
                if (ress[2].value && !ress[2].value?.err) {
                  let apr = ress[2].value.arps.find(
                    (ap: any) =>
                      el.prover.toUpperCase() === ap.proverAddr.toUpperCase()
                  );
                  stakeData[idx].apr = Number(apr?.aprBps);
                  stakeData[idx].aprFormatted = apr?.aprBps
                    ? (apr?.aprBps / 100).toFixed(2)
                    : "0";
                }
              } else {
                stakeData[idx].apr = 0;
                stakeData[idx].aprFormatted = "0";
              }
            });

            // console.log("provers data:", data);
            stakeData.sort(
              (a, b) => Number(b.proverStaked) - Number(a.proverStaked)
            );
            setStakeList(stakeData);
            setLoading(false);
          }
        });
      }
    );
  }, [address, refreshData]);

  return (
    <div>
      <div className={styles.dashboard}>
        <div
          className={styles.overview}
          style={{ backgroundImage: 'url("/stakeBg2.svg")' }}
        >
          {/* <div
            className={styles.dashboardBg}
            style={{
              backgroundImage: 'url("/stakeBg2.svg")',
            }}
          /> */}
          <div className={styles.overviewLeft}>
            <div className={styles.overviewTitle}>Your Total Stake</div>
            <div className={styles.overviewNum}>
              <Popover
                placement="top"
                content={`${totalStakeDecimal} ${tokenSymbol}`}
                rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
                getPopupContainer={(triggerNode) =>
                  triggerNode.parentElement || document.body
                }
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ width: 150 }}>
                      <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 1, width: 150 }}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    {totalStake} {totalStake && tokenSymbol}
                  </div>
                )}
              </Popover>
            </div>
          </div>
          <div className={styles.overviewRight}>
            {!!Number(totalPending) && (
              <div className={styles.overviewPending}>
                <div className={styles.overviewLightTitle}>
                  Pending in the Unstaking Process{" "}
                  <Popover
                    placement="top"
                    content="Unstaking takes 7 days to process. This is your total unstaked amount that is still pending in the process."
                    rootClassName={styles.stakingPopover}
                  >
                    <img src="/info.svg" alt="Brevis" width="16px" />
                  </Popover>
                </div>
                <span>
                  <Popover
                    placement="top"
                    content={`${totalPendingDecimal} ${tokenSymbol}`}
                    rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement || document.body
                    }
                  >
                    {totalPending} {tokenSymbol}
                  </Popover>
                </span>{" "}
              </div>
            )}
            {!!Number(totalWithdrawable) && (
              <div className={styles.overviewWithdrawable}>
                <div className={styles.overviewLightTitle}>
                  Withdrawable{" "}
                  <Popover
                    placement="top"
                    content="This is your total unstaked amount that has passed the 7-day process window and can be withdrawn immediately"
                    rootClassName={styles.stakingPopover}
                  >
                    <img src="/info.svg" alt="Brevis" width="16px" />
                  </Popover>
                </div>
                <span>
                  <Popover
                    placement="top"
                    content={`${totalWithdrawableDecimal} ${tokenSymbol}`}
                    rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement || document.body
                    }
                  >
                    {totalWithdrawable} {tokenSymbol}
                  </Popover>
                </span>{" "}
              </div>
            )}
          </div>
          {
            // <div className={styles.overviewTips}>
            //   <img
            //     src={whiteWarn}
            //     alt="whiteWarn"
            //     style={{ marginRight: 4, marginLeft: 12 }}
            //   />
            //   Your staking rewards are <span>automatically compounded</span>
            //    into your total stakes on a <span>daily basis</span>.
            // </div>
            <div className={styles.overviewTips}>
              <img
                src={whiteWarn}
                alt="whiteWarn"
                style={{ marginRight: 4, marginLeft: 12 }}
              />
              <div>
                Your staking rewards are <span>automatically compounded</span>
                 into your total stakes on a <span>daily basis</span>.
              </div>
            </div>
          }
          {/* <div className={styles.overviewLine} /> */}
          {/* <div className={styles.overviewRight}>
            <div>
              <div className={styles.overviewTitle}>Your Total Rewards</div>
              <div className={styles.overviewNum}>
                {totalRewards} {stakeSymbol}{" "}
              </div>
            </div>
            <div className={styles.overviewBtn}>Claim Rewards</div>
          </div> */}
        </div>
        {
          <div className={styles.stakingDetails}>
            <div className={styles.stakingTitle}>Your Staking Details</div>
            {loading ? (
              <div className={styles.loadingBody}>
                <div
                  className={styles.checkingMotion}
                  style={{ marginTop: 12, marginBottom: 20 }}
                >
                  <div className={styles.checkingMotionThumb}></div>
                </div>
              </div>
            ) : stakeList.length ? (
              <div className={styles.stakingCardRow}>
                {stakeList.map((stake, index) => (
                  <StakeCard stake={stake} key={index} />
                ))}
              </div>
            ) : (
              <div className={styles.stakingCardEmpty}>
                <img
                  src={
                    "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/emptyCat.svg"
                  }
                  alt="emptyCat"
                />
              </div>
            )}
          </div>
        }
      </div>

      {showStakeModal && <StakeModal />}
      {showUnStakeModal && <UnStakeModal />}
    </div>
  );
}
